// extracted by mini-css-extract-plugin
module.exports = {"info":"TalentExplainer_info__OB9fK","itemTitle":"TalentExplainer_itemTitle__2dqR_","itemLeft":"TalentExplainer_itemLeft__mmn8R","itemRight":"TalentExplainer_itemRight__lWADB"};